module.exports = __webpack_public_path__ + "static/media/typea.e3d493f3.jpg";